import { render, staticRenderFns } from "./adddirectly.vue?vue&type=template&id=5c19a9bc&scoped=true&"
import script from "./adddirectly.vue?vue&type=script&lang=js&"
export * from "./adddirectly.vue?vue&type=script&lang=js&"
import style0 from "./adddirectly.vue?vue&type=style&index=0&id=5c19a9bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c19a9bc",
  null
  
)

export default component.exports